import { render, staticRenderFns } from "./ajout.vue?vue&type=template&id=be72010e&"
import script from "./ajout.vue?vue&type=script&lang=js&"
export * from "./ajout.vue?vue&type=script&lang=js&"
import style0 from "./ajout.vue?vue&type=style&index=0&id=be72010e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports